/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "../actions/actionTypes";

// initialState
const initialState = {
  usersVehiclesInfo: {
    vehicles: [],
    pairedUsers: []
  }
};

/**
 * Capture actions dispatched and modify state accordingly
 * @param {*} state -> updated state
 * @param {*} action -> type of action dispatched
 */
const vehicle = (state = initialState, action) => {
  switch (action.type) {
    // set vehicles and paired users data
    case actionTypes.SET_VEHICLE:
      return {
        usersVehiclesInfo: action.usersVehiclesInfo
      };

    default:
      return state;
  }
};

export default vehicle;
